import styled from 'styled-components';

export const Nudge = styled.div`
  display: flex;
  align-items: flex-start;
  background: #039cad;
  width: 100%;
  z-index: 1000;
  justify-content: space-between;
  height: 52px;
  color: #fff;
  transition: margin-top 0.2s;
  font-size: 16px;
`;

export const NudgeInner = styled.div`
  display: flex;
  margin: 14px;
  margin-left: 24px;
`;

export const NudgeMessage = styled.div`
  display: flex;
  flex-direction: column;
`;

export const NudgeLink = styled.div`
  margin-left: 12px;
  .nudge-info-link {
    color: #fff;
    font-weight: 600;
  }
`;

export const NudgeDismiss = styled.div`
  margin: 12px;
`;
